// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminExecutionEvents = {
  actions: {
    retry: "Retry",
    retryTask: "Retry Task",
    processAutoRetries: "Process Due Auto Retries",
  },
  drawer: {
    title: "Execution Task #{id}",
    titleShort: "Execution Task",
    eventTitle: "Runtime Event #{id}",
    eventTitleShort: "Runtime Event",
    rawEventTitle: "Raw Event #{id}",
    rawEventTitleShort: "Raw Event",
    requestPayload: "Request Payload",
    resultPayload: "Execution Result",
  },
  fields: {
    taskId: "Linked Task ID",
    eventAction: "Action",
    eventTrigger: "Trigger",
    workerId: "Worker ID",
    requiredCapability: "Required Capability",
    dispatchDecision: "Dispatch Decision",
    leaseOwner: "Lease Owner",
    leaseExpiresAt: "Lease Expires At",
    retrySource: "Retry Source",
    rootTask: "Root Task",
    retryDepth: "Retry Depth",
    retryCount: "Retries Triggered",
    autoRetryEnabled: "Auto Retry",
    autoRetryState: "Auto Retry State",
    autoRetryMax: "Auto Retry Limit",
    autoRetryDelay: "Auto Retry Interval",
    nextRetryAt: "Next Retry",
    latestRetry: "Latest Retry",
    startTime: "Start Time",
    finishTime: "Finish Time",
  },
  columnHelp: {
    event: "This record describes the platform event in a readable form.",
    resource:
      "The object affected by this event, such as an execution task or environment instance.",
    status: "The recorded result status for this event, not the full technical log.",
    eventConclusion:
      "A business and governance oriented conclusion summarized from status, dispatch decision, and payload.",
    eventCategory:
      "Groups events into task, dispatch, lease, recovery, and other categories for quicker scanning.",
  },
  messages: {
    taskDetailLoadFailed: "Failed to load task details",
    taskRetryStarted: "Retry task #{id} has been started",
    taskRetryFailed: "Failed to retry task",
    autoRetryProcessed:
      "Scanned {scanned}, triggered {triggered}, dispatch failed {dispatchFailed}",
    autoRetryProcessFailed: "Failed to process auto retries",
  },
  values: {
    retryable: "Retryable",
    retried: "Retried",
    succeeded: "Succeeded",
    exhausted: "Not Retryable",
    retryScheduled: "Auto Retry Pending",
    scheduled: "Auto Retry Pending",
    processing: "Processing",
    dispatchRetried: "Retry Dispatched",
    dispatchFailed: "Dispatch Failed",
    deadLettered: "Dead Lettered",
    manualInterventionRequired: "Manual Intervention Required",
    autoRetryExhausted: "Auto Retry Exhausted",
    pending: "Pending",
    running: "Running",
    success: "Succeeded",
    failed: "Failed",
    cancelled: "Cancelled",
    eventTaskPending: "Task queued",
    eventTaskClaimed: "Task claimed",
    eventTaskClaimReleased: "Task claim released",
    eventTaskRunning: "Task started",
    eventTaskSucceeded: "Task succeeded",
    eventTaskFailed: "Task failed",
    eventTaskCancelled: "Task cancelled",
    eventTaskCancellationRequested: "Cancellation requested",
    eventTaskLeaseRenewed: "Task lease renewed",
    eventTaskClaimConflicted: "Task claim conflicted",
    eventTaskDispatchCapabilityMismatch: "Dispatch capability mismatch",
    eventTaskDispatchRateLimited: "Dispatch rate limited",
    eventTaskAutoRetryDispatchFailed: "Auto-retry dispatch failed",
    eventTaskAutoRetryDeadLettered: "Auto-retry dead lettered",
    eventTaskAutoRetryManualInterventionRequired: "Auto-retry requires manual intervention",
    eventTaskStaleRunningDetected: "Stale task entered recovery",
    eventStatusRecorded: "Recorded",
    eventCategoryTask: "Task",
    eventCategoryDispatch: "Dispatch",
    eventCategoryLease: "Lease",
    eventCategoryRecovery: "Recovery",
    eventCategoryOther: "Other",
    resourceExecutionTask: "Execution Task",
    resourceEnvironmentInstance: "Environment Instance",
    resourceExecutionTaskWithId: "Execution Task #{id}",
    resourceEnvironmentInstanceWithId: "Environment Instance #{id}",
    eventConclusionSuccess: "Completed with a successful result recorded",
    eventConclusionFailed: "Execution failed and needs investigation",
    eventConclusionFailedWithReason: "Execution failed: {reason}",
    eventConclusionRetryState: "Current retry state: {value}",
  },
} as const;
